import React from 'react';
import { Clock } from 'lucide-react';
import SystemHeader from './SystemHeader';

const CustomerList = ({ userInfo, accessToken, onLogout, totalPoints = 0 }) => {
  // Logic fetching disabled as per requirement

  const getAgentInfo = () => {
    // Extract agent info from userInfo or use default
    const agentName = userInfo?.name || userInfo?.fullName || 'Trần Văn Bình';
    const agentId = userInfo?.id || '7755';
    return { name: agentName, id: agentId };
  };

  const agentInfo = getAgentInfo();

  // Extra info for header - customer count (disabled/hidden)
  const extraInfo = null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 to-brand-100">
      {/* System Header */}
      <SystemHeader
        userInfo={userInfo}
        onLogout={onLogout}
        totalPoints={totalPoints}
        pageTitle="Danh sách khách hàng"
        pageSubtitle={`Đại lý: ${agentInfo.name} (${agentInfo.id})`}
        extraInfo={extraInfo}
      />

      {/* Message Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden p-8 text-center">
          <div className="mb-6">
            <Clock className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
              Thời gian để đại lý duyệt đơn cho KH tham gia chương trình tri ân "Mua 10 tặng 1" đã kết thúc
            </h2>
            <p className="text-gray-600 text-base sm:text-lg">
              Nếu có thắc mắc hoặc cần hỗ trợ về chương trình, vui lòng liên hệ Trâm, Diệu, Chi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
